import { render, staticRenderFns } from "./PropertyLayout.vue?vue&type=template&id=b618f9b6&scoped=true&lang=pug&"
import script from "./PropertyLayout.vue?vue&type=script&lang=js&"
export * from "./PropertyLayout.vue?vue&type=script&lang=js&"
import style0 from "./PropertyLayout.vue?vue&type=style&index=0&id=b618f9b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b618f9b6",
  null
  
)

export default component.exports